export const RiyalSymbol = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ?? "17"}
      height={props.height ?? "18"}
      viewBox={props.viewBox ?? "0 0 17 18"}
      fill={props.fill ?? "none"}
    >
      <g clipPath="url(#clip0_20517_14164)">
        <path
          d="M10.5783 15.9382C10.2754 16.5752 10.0752 17.2664 9.99854 17.9912L16.4077 16.699C16.7105 16.0622 16.9106 15.3709 16.9874 14.646L10.5783 15.9382Z"
          fill={props.fill ?? "#FAFAFA"}
        />
        <path
          d="M16.4078 12.8277C16.7107 12.1909 16.9108 11.4995 16.9875 10.7747L11.995 11.7818V9.84573L16.4076 8.95633C16.7105 8.31952 16.9107 7.62816 16.9874 6.90329L11.9949 7.90955V0.946969C11.2299 1.35437 10.5505 1.89666 9.99822 2.53632V8.31222L8.00155 8.71475V0C7.23655 0.407255 6.55715 0.94969 6.00488 1.58936V9.11714L1.53732 10.0176C1.23446 10.6544 1.03412 11.3457 0.957268 12.0706L6.00488 11.0532V13.4913L0.595376 14.5816C0.292517 15.2184 0.0923213 15.9097 0.015625 16.6346L5.67786 15.4933C6.1388 15.4024 6.53496 15.1439 6.79253 14.7882L7.83095 13.328V13.3277C7.93874 13.1767 8.00155 12.9945 8.00155 12.7983V10.6506L9.99822 10.2481V14.1202L16.4076 12.8274L16.4078 12.8277Z"
          fill={props.fill ?? "#FAFAFA"}
        />
      </g>
      <defs>
        <clipPath id="clip0_20517_14164">
          <rect
            width={props.width ?? "17"}
            height={props.height ?? "18"}
            fill={props.fill ?? "white"}
          />
        </clipPath>
      </defs>
    </svg>
  );
};
